import styled from 'styled-components';
import FloatingActionButton from '../../atoms/FloatingActionButton/';
import IconButton from '../../atoms/IconButton';
import {QuestionIcon} from '../../atoms/Icons';
import {HideLogo,UnhideLogo} from '../../atoms/Logo';
import {DividerColor,SurfaceColor,Grey100,Grey300,AccentColor} from '../../Colors';

const defaultStyle = {
	AnswerText : styled.span`
		color:red;
		font-weight: bold;
	`,
	EditorWrapper : styled.div`
		margin-top : 5px;
		border: none;
		border-radius: 5px;
		outline: none;
		overflow-y: scroll;
		border: 1px solid ${DividerColor};
		height:100%;
		min-height : 5rem;
	`,
	Edditor : styled.div`
		padding : 10px;
		cursor: text;
	`,
	ButtonWrapper : styled.div`
		background-color : ${Grey100};
		border-bottom: 1px solid ${Grey300};
		padding : 5px;
		text-align : center;
	`,
	ConvertButton : styled(FloatingActionButton)`
		border-radius : 50%;
		min-width : 4rem;
		height : 4rem;
		margin-right : 0.1rem;
	`,
	HideIcon : styled(HideLogo)`
		height : 1em;
		width : auto;
	`,
	UnhideIcon : styled(UnhideLogo)`
		height : 1em;
		width : auto;
	`,
	IconButton,
	QuestionIcon : styled(QuestionIcon)`
		color : ${AccentColor};
	`,
	Footer : styled.div`
		display : flex;
		padding : 1rem;
		justify-content: flex-end;
		& > div{
			margin-right : 0.5rem;
		}
	`,
};

const mobileStyle = {
	Wrapper : styled.div`
		& > h4 {
			margin-bottom : 1rem;
		}
	`,
};

const demoStyle = {
	EditorWrapper : styled.div`
		margin-top : 5px;
		border: none;
		border-radius: 5px;
		outline: none;
		overflow-y: scroll;
		border: 1px solid ${DividerColor};
		height:100%;
		min-height : 5rem;
		background-color : ${SurfaceColor};
	`,
};

const mobileDemoStyle = {
};

export default defaultStyle;
export {mobileStyle,demoStyle,mobileDemoStyle};